import TrendSearchFilters from "./SearchFilters";
import './SearchFilters.scss';

export default TrendSearchFilters;